import {Component, OnInit} from '@angular/core';
import {PostService} from "../../../../service/forum/post.service";
import {ReplyService} from "../../../../service/forum/reply.service";
import {Reply} from "../../../../domain/reply";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../../../../../core/security/auth.service";
import {User} from "../../../../../core/domain/user";
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from "@angular/router";
import {routerTransitionSlideToleft, routerTransitionDropFromTop} from "../../../../animations/router.animations";

@Component({
    selector: 'app-reply-form',
    templateUrl: './reply-form.component.html',
    styleUrls: ['./reply-form.component.scss'],
    providers: [PostService, ReplyService],
    animations: [ routerTransitionDropFromTop() ],
    host: {'[@routerTransition]': ''}
})
export class ReplyFormComponent implements OnInit {

    public reply: Reply = null;
    public update: boolean = false;
    public replyForm: FormGroup;
    private user : User;
    public navTitle : string = "Volver al post";

    constructor(private postService: PostService,
                private replyService: ReplyService,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private authService: AuthService,
                private location: Location,
                private router: Router) {

        this.replyForm = this.formBuilder.group({
            id: [null],
            content: ['', Validators.required]
        });
    }

    ngOnInit() {

        let id = this.route.params
            .map(params => params['id']);

        id.filter(id => id != 'new')
            .switchMap(id => this.replyService.get(+id))
            .subscribe(reply => {
                this.reply = reply;
                this.replyForm.get("content").setValue(this.reply.content);
                this.replyForm.get("id").setValue(this.reply.id);
                this.update = true;
            });

        id.filter(id => id == 'new')
            .switchMap(id => this.route.params)
            .map(params => +params['postId'])
            .switchMap(id => this.postService.get(id))
            .subscribe(post => {
                this.reply = new Reply();
                this.reply.post = post;
                this.reply.replyTime = null;
            });

        this.authService.user
            .subscribe(u => this.user = u);
    }

    public formToEntity( value ) : Reply {
        let r = new Reply();
        r.id = value.id;
        r.content = value.content;
        r.user = this.user;
        r.post = this.reply.post;
        if ( !this.update )
            r.replyTime = new Date().getTime();
        else
            r.replyTime = this.reply.replyTime;
        return r;
    }

    public save( {value, vadid}){
        let r = this.formToEntity(value);
        if ( !this.update ){
            this.replyService.create(r)
                .subscribe(r => this.router.navigate(["home","post",this.reply.post.id]) );
        } else {
            this.replyService.update(r)
                .subscribe(r => this.router.navigate(["home","post",this.reply.post.id]) );
        }
    }

    public goBack() {
        this.location.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/reply-form/reply-form.component.ts